// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_mb-0";